import { render, staticRenderFns } from "./badgesView.vue?vue&type=template&id=1283b40a&scoped=true&"
import script from "./badgesView.vue?vue&type=script&lang=js&"
export * from "./badgesView.vue?vue&type=script&lang=js&"
import style0 from "./badgesView.vue?vue&type=style&index=0&id=1283b40a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1283b40a",
  null
  
)

export default component.exports